export const accessLevels = [
  { label: 'Переглядач', value: 1 },
  { label: 'Адміністратор', value: 2 },
  { label: 'Керівник', value: 3 },
];
